import { GridFieldAuthorization } from '../administration/securityLevel';

export class GridFieldTextListing {
  id: number;
  currentText: string;
}

export class GridFieldTextSummary extends GridFieldTextListing {
  text: string;
  languageId: number;
  gridFieldDefinition: GridFieldDefinition;
  isRequired?: boolean
}


export class GridFieldDefinition {
  id: number;
  objectCode: string;


  constructor(){
    this.id = 0;
    this.objectCode = '';
  }
}


export class GridFieldDefinitionSummary extends GridFieldDefinition {
  isCustomField: boolean;
  gridFieldText: GridFieldTextSummary;
  gridFieldAuthorizations: GridFieldAuthorization[];
}
